export default __webpack_public_path__ + "static/preview-platform-0bde78f6b824ae122120707476873b3c.gif";